module.exports = __webpack_public_path__ + "png/marker/marker.png";